

import { defineComponent } from "vue";

import Headbar from '../components/headbar.vue';
import Footer from '~/components/footer.vue';


export default defineComponent({
    components: {
        Headbar,
        Footer,
    },

    computed: {
        forbidden() {
            return require('@/forbidden.gif').default;
        }
    }
})

